<template>
  <div v-if="tabs" class="tab-panel-container py-2 px-3">
    <DxTabPanel height="70%">
      <DxItem v-for="(tab, index) in tabs" :key="index" :title="tab.title" class="tab-item" :disabled="tab.disabled">
        <component :is="tab.component" v-bind="tab.props"></component>
      </DxItem>
    </DxTabPanel>
  </div>
</template>

<script setup lang="ts">
import { useIntl } from '@services/i18n';
import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
import TiposDocumentosOperacionGrid from '@/components/tipo-documento-empresa-servicios/TiposDocumentosEmpresaServiciosGrid.vue';

const props = defineProps({
  idEmpresaServicios: String
});

const intl = useIntl();
const tabs = [
  { title: intl.i18n.t('tipos_documentos_operacion.titulo'), component: TiposDocumentosOperacionGrid, props: { idEmpresaServicios: props.idEmpresaServicios }, disabled: false },  
];

</script>

<style lang="scss" scoped>


.tab-panel-container {
  background-color: var(--background-surface-default);
  border: 1px solid var(--border-default-default);
  border-radius: 5px;
}

.dx-tabpanel-container {
  padding-top: 15px;
}
</style>